import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import notfound from "../assets/images/404-error.png";
import { useSelector } from "react-redux";
import Loader from "../components/utils/Loader";

const PageNotFound = () => {
  const { getUserPanelAccessLoading } = useSelector(state => state.generic);
  const { loading } = useSelector((state) => state.auth);
  const [startLoadingFlag, setStartLoadingFlag] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setStartLoadingFlag(false)
    }, 600)
  }, [])

  return (
    <> {(startLoadingFlag || getUserPanelAccessLoading || loading) ? <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "100vh" }}
    >
      <Loader />
    </div> :
      <div className="d-flex justify-content-center align-items-center flex-column" style={{ minHeight: "70vh" }} >
        <img
          src={notfound}
          alt="Page not found"
          className="img-fluid"
          style={{ width: "100%", maxWidth: "400px", height: "auto", }}
        />
        <p
          className="text-muted text-center mx-auto px-3"
          style={{ maxWidth: "600px", width: "100%", }}
        >
          Sorry, the page you’re looking for doesn’t exist or you don’t have permission
          to access it. Please contact your administrator for assistance.
        </p>

        <Link to="/" className="btn btn-primary mt-4">
          Go To Dashboard <i className="ri-arrow-right-long-line"></i>
        </Link>
      </div>
    }
    </>
  );
};

export default PageNotFound;